import { IncludeHeader, proxyClientOptions, RestfulClient, Session } from '@benzinga/session';
import { SafePromise } from '@benzinga/safe-await';
import { BullVsBearResponse } from '../../entities';
import { QuotesEnvironment } from '../../environment';
import { quotesBullSayBearSayRoutes } from './routes';
import { QuotesBullSayBearSayTransport } from './types';

export class QuotesBullSayBearSayRestful extends RestfulClient implements QuotesBullSayBearSayTransport {
  constructor(session: Session, includeHeaders?: IncludeHeader) {
    const env = session.getEnvironment(QuotesEnvironment);
    super(env.bullSayBearSayUrl, session, includeHeaders, proxyClientOptions());
  }

  getStatements = (symbols: string[]): SafePromise<BullVsBearResponse> => {
    const env = this.session.getEnvironment(QuotesEnvironment);
    const path = this.routePath(quotesBullSayBearSayRoutes.statements);
    const url = this.URL(
      path,
      this.withUpstreamCredentials({ symbols: symbols.join(',') }, { token: env.bullSayBearSayToken }),
    );
    return this.get(url, { allowsAnonymousAuth: true });
  };
}
